<template>
  <div class="table-responsive">
    <table class="table table-striped order-summary">
      <thead class="active">
        <tr>
          <th class="order-number">Order Number</th>
          <th class="order-date">Completed At</th>
          <th class="order-status">Order Status</th>
          <th class="order-payment-state">Payment State</th>
          <th class="order-shipment-state">Shipment State</th>
          <th class="order-total">Total</th>
          <th class="order-action">&nbsp;</th>
        </tr>
      </thead>
      <order-row
        v-for="order in orders"
        :key="order.number"
        :order="order"
      />
    </table>
  </div>
</template>

<script>
  import OrderRow from "./order-row";

  export default {
    components: {
      OrderRow,
    },
    props: {
      orders: {
        type: Array,
        required: true,
      },
    }
  };
</script>
